module.exports = __webpack_public_path__ + "img/about-bg.98776a80.png";